<template>
  <div class="email-container public-tab-container">
    <div class="email-input input-row">
      <div class="value">
        <input type="text" v-model="emailData.emailVal" :placeholder="$t('signUp.text26')" />
      </div>
    </div>

    <!-- 验证码输入框 -->
    <div class="code-input input-row" v-show="isVerificationCode">
      <div class="value">
        <input class="value_code" v-model="codeData.codeVal" type="text" :placeholder="$t('signUp.text15')" />
      </div>
      <el-button class="send" link @click="sendCode">{{ codeData.sendMessage }}</el-button>
    </div>

    <!-- 密码输入框 -->
    <div class="pwd-input input-row" v-show="!isVerificationCode">
      <div class="value">
        <input :type="pwdData.isPasswordType ? 'text' : 'password'" :placeholder="$t('signUp.text27')"
          v-model="pwdData.pwdVal" />
      </div>
      <span class="password-icon">
        <img
          :src="pwdData.isPasswordType ? 'https://ehammer.oss-cn-hangzhou.aliyuncs.com/web/icon_eye_yes.png' : 'https://ehammer.oss-cn-hangzhou.aliyuncs.com/web/icon_eye_no.png'"
          @click="pwdData.isPasswordType = !pwdData.isPasswordType;" class="pw-icon" />
      </span>
    </div>

    <!-- 登录按钮 -->
    <div :class="isLoginEnabled ? '' : 'btn-disabled'" class="login-btn" @click="logins">
      {{ isVerificationCode ? $t('signUp.text22') : $t('signUp.text22_1') }}
    </div>

    <!-- 切换验证码登录 / 密码登录 和 忘记密码按钮 -->
    <div class="btn-text-con">
      <!-- 验证码登录模式下：仅显示右侧的“密码登录”按钮 -->
      <button v-if="isVerificationCode" class="public-text-btn btn-text-right" @click="toggleLoginMode(false)">
        {{ $t('signUp.text23') }}
      </button>

      <!-- 密码登录模式下：左侧显示“验证码登录”按钮，右侧显示“忘记密码”按钮 -->
      <div v-else>
        <button class="public-text-btn btn-text-left" @click="toggleLoginMode(true)">
          {{ $t('signUp.text46') }}
        </button>
        <button @click="jumpToForgetPwd" class="forget-pwd public-text-btn btn-text-right">
          {{ $t('signUp.text25') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, reactive, inject, computed } from 'vue';
import apiService from '@/api/request';
import { ElMessage } from 'element-plus';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import { useI18n } from "vue-i18n";
import { loadErrorCallback } from '@/until/common';

export default {
  name: 'EmailLogin',
  setup() {
    const { t, locale } = useI18n();
    const emitt = inject('emitt');
    const store = useStore();
    const router = useRouter();

    const emailData = reactive({ emailVal: '', isEmailErr: false, errText: '' });
    const pwdData = reactive({ isPasswordType: false, pwdVal: '', isPwdErr: false });
    const codeData = reactive({ codeVal: '', sendMessage: t('signUp.text16') });
    const isVerificationCode = ref(true); // 切换验证码和密码登录模式
    const isSending = ref(false); // 控制验证码发送状态
    const time = ref(60); // 倒计时时间
    let timer = null;
    const lang = computed({ get: () => store.getters.getNowTheme.lang });

    // 切换登录模式
    function toggleLoginMode(useCode) {
      isVerificationCode.value = useCode;
    }

    const checkEmailPatern = (value) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);

    const isLoginEnabled = computed(() => {
      return emailData.emailVal && (isVerificationCode.value ? codeData.codeVal : pwdData.pwdVal);
    });

    const jumpToForgetPwd = () => {
      emitt.$pub('switchForget', { status: false, type: 'email' });
    };

    // 发送验证码，使用手机号登录模块中的逻辑
    const sendCode = async () => {
      if (isSending.value) {
        return;
      }
      if (!emailData.emailVal || !checkEmailPatern(emailData.emailVal)) {
        ElMessage({ message: t('signUp.text43'), type: 'error' });
        return;
      }
      sendCodeFunc({ret:0})
    };

    async function sendCodeFunc(result) {
      console.log(result);
      if (result.ret !== 0) return;
      if (timer) return;

      isSending.value = true;
      codeData.sendMessage = t('signUp.text18'); // 更新发送状态
      const params = {
        smsType: 31,
        email: window.btoa(emailData.emailVal),
        lang: locale.value,
        ticket: result.ticket,
        randstr: result.randstr,
      };
      const res = await apiService.GetByEmail(params);
      if (res.status === 1) {
        ElMessage({ message: t('signUp.text19'), type: 'success' });
        codeData.sendMessage = `${time.value}S`;
        timer = setInterval(() => {
          codeData.sendMessage = `${time.value}S`;
          time.value -= 1;
          if (time.value <= 0) {
            isSending.value = false;
            clearInterval(timer);
            codeData.sendMessage = t('signUp.text17');
            time.value = 60;
            timer = null;
          }
        }, 1000);
      } else {
        ElMessage({ message: res.message, type: 'error' });
        codeData.sendMessage = t('signUp.text16');
        isSending.value = false;
      }
    }

    // 执行登录
    let loginNow = false;
    const logins = async () => {
      if (loginNow) {
        return;
      }

      // 检查邮箱格式是否正确
      if (!emailData.emailVal || !checkEmailPatern(emailData.emailVal)) {
        emailData.isEmailErr = true;
        ElMessage({
          message: t('signUp.text43'), // 邮箱格式错误提示
          type: 'error',
        });
        return;
      }

      // 验证是否为验证码登录方式，检查验证码或密码是否填写
      if (isVerificationCode.value && !codeData.codeVal) {
        codeData.isVerticodeErr = true;
        return;
      } else if (!isVerificationCode.value && !pwdData.pwdVal) {
        pwdData.isPwdErr = true;
        return;
      }

      loginNow = true;

      if (!isVerificationCode.value) {
        // 密码登录方式
        const params = {
          account: window.btoa(emailData.emailVal),
          passWord: pwdData.pwdVal,
          userAgent: window.navigator.userAgent,
        };

        const res = await apiService.Login(params);
        if (res.status === 1) {
          // 如果用户中心无权限 且不是代理系统管理员 且不是跟单系统管理员，弹出暂无权限提示
          if (!res.data.hasCrmPermission && !(res.data.hasProxyPermission && res.data.isProxyAdmin) && !(res.data.hasTraderPermission && res.data.isTrader)) {
            ElMessage({
              message: t('signUp.text45'),
              type: 'error',
            })
            loginNow = false;
            return;
          }
          
          // 提示登录成功
          ElMessage({
            message: t('signUp.text21'),
            type: 'success',
          })
          store.commit('USERTOKEN', res.data.userToken);

          // 如果用户中心无权限时，登录应该直接跳转到代理系统/跟单系统
          if (!res.data.hasCrmPermission) {
            if (res.data.hasProxyPermission && res.data.isProxyAdmin) {
              router.push({
                name: 'agentDashboard'
              });
            } else if (res.data.hasTraderPermission && res.data.isTrader) {
              router.push({
                name: 'followorderaccount'
              });
            }
            loginNow = false;
            return;
          }
          await store.dispatch('getUserInfo');
          await store.dispatch('getUserStatus');

          if (res.data.ostatus !== 3) {
            router.push({ name: 'myAccount' });
          } else {
            router.push('transaction');
          }
        } else {
          // 密码错误提示
          ElMessage({
            message: res.message,
            type: 'error',
          });
          pwdData.isPwdErr = true;
        }
        loginNow = false;
      } else {
        // 验证码登录方式
        const params = {
          email: window.btoa(emailData.emailVal),
          vcode: codeData.codeVal,
          userAgent: window.navigator.userAgent,
          "registerTag.tag": sessionStorage.tag || 'Official Website',
          "registerTag.keywords": sessionStorage.keywords || '',
          "registerTag.campaign": sessionStorage.campaign || '',
          "registerTag.tag1": sessionStorage.tag1 || '',
          "registerTag.tag2": sessionStorage.tag2 || '',
          "registerTag.tag3": sessionStorage.tag3 || '',
          "registerTag.language": sessionStorage.language || '',
          loginMode: 2, // 1手机（默认） 2邮箱
        };

        apiService.LoginV2(params).then(async (res) => {
          if (res.status === 1) {
            // 如果用户中心无权限 且不是代理系统管理员 且不是跟单系统管理员，弹出暂无权限提示
            if (!res.data.userInfo.hasCrmPermission && !(res.data.userInfo.hasProxyPermission && res.data.userInfo.isProxyAdmin) && !(res.data.userInfo.hasTraderPermission && res.data.userInfo.isTrader)) {
              ElMessage({
                message: t('signUp.text45'),
                type: 'error',
              })
              loginNow = false;
              return;
            }
            
            // 提示登录成功
            ElMessage({
              message: t('signUp.text21'),
              type: 'success',
            })
            store.commit('USERTOKEN', res.data.userToken);

            // 如果用户中心无权限时，登录应该直接跳转到代理系统/跟单系统
            if (!res.data.userInfo.hasCrmPermission) {
              if (res.data.userInfo.hasProxyPermission && res.data.userInfo.isProxyAdmin) {
                router.push({
                  name: 'agentDashboard'
                });
              } else if (res.data.userInfo.hasTraderPermission && res.data.userInfo.isTrader) {
                router.push({
                  name: 'followorderaccount'
                });
              }
              loginNow = false;
              return;
            }
            await store.dispatch('getUserInfo');
            await store.dispatch('getUserStatus');

            if (res.data.isRegist === 1) {
              const jumpParams = { type: 'setPassword' };
              emitt.$pub('switchForget', jumpParams);
            } else {
              if (res.data.userInfo.ostatus !== 3) {
                router.push({ name: 'myAccount' });
              } else {
                router.push('transaction');
              }
            }
          } else {
            // 验证码错误提示
            ElMessage({
              message: t('signUp.text44'),
              type: 'error',
            });
            codeData.isVerticodeErr = true;
          }
          loginNow = false;
        });
      }
    };


    return {
      emailData,
      pwdData,
      codeData,
      isVerificationCode,
      toggleLoginMode,
      jumpToForgetPwd,
      sendCode,
      logins,
      isLoginEnabled,
    };
  },
};
</script>

<style lang="less" scope>
.email-container {
  .input-row {
    margin: 0 auto;
    margin-top: 24px;
    /*no*/
    background: white;
    display: flex;
    justify-content: left;
    margin-bottom: 16px;
    /*no*/
    border-radius: 4px;
    /*no*/
    height: 48px;
    /*no*/
    position: relative;
    border: 1px solid @border-color-base;
    /*no*/
    width: 400px;

    /*no*/
    .value {
      width: 100%;
    }

    .password-icon {
      position: absolute;
      right: 16px;
      /*no*/
      top: 14px;
      /*no*/
      cursor: pointer;
    }

    .send {
      position: absolute;
      right: 10px;
      /*no*/
      top: 11px;
      /*no*/
      font-size: 14px;
      /*no*/
    }

    .prefix {
      width: 85px;
      padding-left: 10px;
      border-right: 1px solid @border-color-base;
      /*no*/
      text-align: left;
      cursor: pointer;
      position: relative;
      line-height: 48px;

      .icon_search {
        position: relative;
        top: 8px;
      }

      .icon_choice {
        width: 8px;
        /*no*/
        position: absolute;
        right: 9px;
        top: 22px;
      }
    }

    input {
      height: 46px;
      /*no*/
      line-height: 46px;
      /*no*/
      border-radius: 4px;
      /*no*/
      outline: none;
      padding-left: 10px;
      /*no*/
      width: 100%;
      font-size: 14px;
      /*no*/
    }

    .value_code {
      padding-left: 10px;
    }

    .select_region {
      position: absolute;
      left: 0;
      padding: 20px 0;
      background: white;
      width: 300px;
      height: 490px;
      z-index: 9;
      top: 58px;
      box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.1);
      display: none;

      h3 {
        font-size: 16px;
        text-align: center;
        color: #111E36;
        position: relative;

        img {
          display: none;
        }
      }

      .seach {
        width: 284px;
        height: 28px;
        background: #F6F6F6;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
        padding-left: 13px;
        margin-top: 19px;

        img {
          display: block;
          width: 12px;
          height: 12px;
          position: relative;
          top: 8px;
        }

        input {
          width: 243px;
          height: 28px;
          background: #F6F6F6;
          line-height: 28px;
        }
      }

      ul {
        width: 100%;
        height: 360px;
        margin-top: 12px;
        overflow-y: scroll;

        li {
          height: 45px;
          padding: 13px 16px;
          border-bottom: 1px solid #F8F9FB;
          cursor: pointer;
        }

        li:hover {
          background: #FEE3D1;
        }
      }
    }
  }

  .login-btn {
    width: 400px;
    /*no*/
    height: 48px;
    /*no*/
    margin: 0 auto;
    margin-top: 50px;
    /*no*/
    line-height: 48px;
    /*no*/
    background: @primary-color;
    border-radius: 2px;
    /*no*/
    font-size: 14px;
    /*no*/
    font-family: MicrosoftYaHei;
    color: #FFFFFF;
    cursor: pointer;
  }

  .btn-text-con {
    width: 400px;
    /*no*/
    position: relative;
    height: 20px;
    /*no*/
    margin: 0 auto;
    margin-top: 16px;

    /*no*/
    .public-text-btn {
      position: absolute;
      font-size: 14px;
      /*no*/
      font-family: MicrosoftYaHei;
      color: @primary-color;
      background: transparent;
      cursor: pointer;
    }

    .btn-text-right {
      right: 0;
    }

    .btn-text-left {
      left: 0;
    }
  }
}
</style>
